import React, { useEffect, useState } from "react";
import ProductivityToolsDescriptionContainer from "../../shared/ProductivityToolsDescriptionContainer/ProductivityToolsDescriptionContainer";
import SearchBar from "./SearchBar";
import { getVocabularySearchedWord } from "../../../redux/actions/vocabularyCenterAction";
import { useDispatch, useSelector } from "react-redux";
import { LEARNER, NON_CASE_SENSITIVE } from "../../../redux/constants";
import OverAllTopicList from "./OverAllTopicList";
import translate from "../../../i18n/translate";
import CreateAudioComponent from "./ReactTable/createAudioComponent";
import TableComponent from "./ReactTable/TableComponent";
import { convertToObject } from "./ReactTable";
import DialogView from "./DialogContents";
import InfoDetails from "./InfoDetails";
import { getSearchedWordDetails } from "./VocabularyCenterPOCUtils";
import { useEffectAfterMount } from "../../common/hooks";
const AudioCell: React.FC<any> = ({ element, setShowInfoDetails }) => {
  return (
    <CreateAudioComponent
      audioPath={element.cell.row.original.audioPath}
      value={element.cell.getValue()}
      view={() => setShowInfoDetails(element.cell.row.original)}
    />
  );
};
const VocabularyCenter = () => {
  const dispatch = useDispatch();
  const { peopleInformation, common, vocabularyContents } = useSelector((state: any) => state);
  const [searchText, setSearchText] = useState<string>("");
  const [showInfoDetails, setShowInfoDetails] = React.useState<boolean>(false);
  const [infoDetails, setInfoDetails] = React.useState<any>({});
  const [addNewWord, setAddNewWord] = React.useState<boolean>(false);

  useEffect(() => {
    if (searchText.length >= 3) {
      getVocabularySearchedWordApiCall();
    }
  }, [searchText]);

  useEffectAfterMount(() => {
    if (searchText.length >= 3 && !vocabularyContents.searchedWordDetails?.word && !vocabularyContents.isWordSearching) {
      setShowInfoDetails(true);
    }
  }, [vocabularyContents.searchedWordDetails]);

  const handleSearch = (e: any) => {
    if (
      (e?.key?.toUpperCase() === "ENTER" && searchText.length > 0) ||
      (e?.target?.id === "search-button" && searchText.length > 0)
    ) {
      if (!vocabularyContents.searchedWordDetails?.word) {
        setShowInfoDetails(true);
      }
    }
  };

  const getVocabularySearchedWordApiCall = () => {
    dispatch(
      getVocabularySearchedWord(
        common.lgId,
        peopleInformation.data.getpeopleInformation.token,
        searchText,
        LEARNER,
        NON_CASE_SENSITIVE,
      ),
    );
  };

  const data = React.useMemo(
    () => vocabularyContents.searchedWordDetails?.word,
    [vocabularyContents.searchedWordDetails],
  );

  const columns: any = React.useMemo(
    () => [
      {
        id: 1,
        header: translate("vocab_center_word_label"),
        accessorKey: "word",
        cell: (element: any) => {
          return <AudioCell element={element} setShowInfoDetails={setShowInfoDetails} />;
        },
      },
      {
        id: 2,
        header: translate("vocab_center_translation_label"),
        accessorKey: "word",
      },
      {
        id: 3,
        header: translate("vocab_center_pos_label"),
        accessorKey: "pos",
      },
      {
        id: 4,
        header: translate("vocab_center_definition_label"),
        accessorKey: "definition",
      },
    ],
    [],
  );
  const checkOptions = [
    {
      name: "Word",
      checked: true,
      id: 1,
    },
    {
      name: "Translation",
      checked: false,
      id: 2,
    },
    {
      name: "Parts of Speech",
      checked: true,
      id: 3,
    },
    {
      name: "Definition",
      checked: true,
      id: 4,
    },
    {
      name: "Sentence",
      checked: true,
      id: 5,
    },
  ];

  return (
    <div className="new-vocabulary-center-container-wrapper">
      <div className="new-vocabulary-center-container" data-testid="Voc-Center">
        <ProductivityToolsDescriptionContainer
          headingTitle="vocab_center_product_headline"
          featureDescription="vocab_center_feature_text"
          featureImg={window.location.origin + "/images/" + "Feature_Illustrations/Vocabulary-center.svg"}
        />

        <SearchBar
          searchText={searchText}
          setSearchText={setSearchText}
          changeClassName={"change-view"}
          handleSearch={handleSearch}
          searchOnly={false}
        />
        {vocabularyContents.searchedWordDetails?.word && searchText.length >= 3 && (
          <TableComponent data={data} columns={columns} Visibility={convertToObject(checkOptions)} />
        )}
        {vocabularyContents.isWordSearching && <div className="loader"> Searching ....</div>}
        <OverAllTopicList />

        <DialogView
          open={showInfoDetails}
          handleClose={() => {
            setShowInfoDetails(false);
            setSearchText("");
            setInfoDetails({});
          }}
          dialogContainerClassNameValue="vocabulary-show-info-details-popup"
          dialogContentsClassName="vocabulary-show-info-details-contents"
          dialogBody={
            <InfoDetails
              handleClose={() => {
                setShowInfoDetails(false);
                setSearchText("");
                setInfoDetails({});
              }}
              infoDetails={getSearchedWordDetails(infoDetails)}
              newWordTitle={searchText}
              openAddWordListDialog={() => console.log("openAddWordListDialog")}
              addNewWord={addNewWord}
              setAddNewWord={setAddNewWord}
              openInfoDialog={setShowInfoDetails}
              showingWordListDetails={() => console.log("showingWordListDetails")}
            />
          }
        />
      </div>
    </div>
  );
};
export default VocabularyCenter;
